import moment from "moment";

export function getDuration(duration: number): string {
  const d = moment.duration(duration, "seconds");
  return `${d.hours().toString().padStart(2, "0")}:${d
    .minutes()
    .toString()
    .padStart(2, "0")}:${d.seconds().toString().padStart(2, "0")}`;
}
